export default "<p>dashboard-line-graph works!</p>\n";